export default function appendCredentials (options?: any): any { // eslint-disable-line class-methods-use-this
  if (options === null || options === undefined) {
    return { credentials: 'include' }
  } if (typeof options !== 'object') {
    const optionsCredentials = {
      credentials: 'include',
    }
    return optionsCredentials
  }
  const optionsCredentials = options
  optionsCredentials.credentials = 'include'
  return optionsCredentials
}
